module.exports = __webpack_public_path__ + "img/world.61a290ff.svg";